// The standalone /app/messages/pending page is superseded by the tabbed
// Messages page. Redirect to the Awaiting tab for backwards compatibility
// (the route is still registered in App.tsx so old bookmarks keep working).
// The AppLayout shell is rendered immediately to avoid a blank-paint flash.

import { useEffect } from "react";
import { useLocation } from "wouter";
import AppLayout from "@/components/app-layout";
import { Loader2 } from "lucide-react";
import { usePageTitle } from "@/hooks/use-page-title";

export default function AppMessagesPending() {
  usePageTitle("Pending Messages");
  const [, navigate] = useLocation();

  useEffect(() => {
    navigate("/app/messages?tab=awaiting", { replace: true });
  }, [navigate]);

  return (
    <AppLayout>
      <div className="flex h-full items-center justify-center text-gray-400">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" />
        Redirecting…
      </div>
    </AppLayout>
  );
}
